import type { NodeViewDecorator, ViewerPlugin } from './../ricos-types/index.js';
import type { ViewerPluginOptions, FontSizePluginConfig } from './../ricos-viewer-next/types.js';

import BoldDecorator from './bold/viewer.js';
import type { FontSizeCommonConfig } from './font-size/types.js';
import { createFontSizeDecorator } from './font-size/viewer.js';
import ItalicDecorator from './italic/viewer.js';
import StrikethroughDecorator from './strikethrough/viewer.js';
import SubscriptDecorator from './subscript/viewer.js';
import SuperscriptDecorator from './superscript/viewer.js';
import UnderlineDecorator from './underline/viewer.js';

export const getNodeViewDecorators = (
  plugins?: (ViewerPlugin | ViewerPluginOptions)[]
): NodeViewDecorator<JSX.Element>[] => {
  const fontSizePluginConfig = plugins?.find(
    (plugin): plugin is FontSizePluginConfig => plugin.type === 'fontSize'
  );
  return [
    BoldDecorator,
    ItalicDecorator,
    UnderlineDecorator,
    createFontSizeDecorator(fontSizePluginConfig),
    StrikethroughDecorator,
    SubscriptDecorator,
    SuperscriptDecorator,
  ];
};
